import PortfolioChart from "./modules/chart/portfolio-chart";
import { useState } from "react";
import { motion } from "framer-motion";
import { Positions } from "@/features/positions";
import { Transactions } from "@/features/transactions";

const COLLAPSED_TOP = "51%";
const COLLAPSED_HEIGHT = "49%";

const RightPanel = () => {
  const [expandedTransactions, setExpandedTransactions] = useState(false);

  return (
    <div className="row-span-2 grid grid-rows-2 gap-y-[0.625rem] relative">
      <PortfolioChart />
      <motion.div
        className="absolute z-10 w-full"
        animate={
          expandedTransactions
            ? { top: 0, height: "100%" }
            : { top: COLLAPSED_TOP, height: COLLAPSED_HEIGHT }
        }
        initial={{ top: COLLAPSED_TOP, height: COLLAPSED_HEIGHT }}
        transition={{ duration: 0.2 }}
      >
        <Transactions
          expanded={expandedTransactions}
          toggleExpanded={() => setExpandedTransactions((prev) => !prev)}
        />
      </motion.div>
    </div>
  );
};

const PortfolioLayout = () => {
  return (
    <div className="h-[calc(100vh-11rem)] px-[0.625rem] grid grid-cols-2 grid-rows-2 gap-[0.625rem] pb-[0.625rem]">
      <div className="row-span-2">
        <Positions />
      </div>
      <RightPanel />
    </div>
  );
};

export default PortfolioLayout;
